import { render, staticRenderFns } from "./InsurancesPlanAdd.vue?vue&type=template&id=2e921e71&scoped=true&"
import script from "./InsurancesPlanAdd.vue?vue&type=script&lang=js&"
export * from "./InsurancesPlanAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e921e71",
  null
  
)

export default component.exports